import React from 'react';
import ReactGA from 'react-ga4';
import debounce from 'lodash/debounce';

import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { LabeledValue, SelectValue } from 'antd/lib/select';
import { Radio, Skeleton, Tooltip } from 'antd';
import { get, isEmpty } from 'lodash';
import { getAmenityImageByName, getBudgetLabel, getHotelsFiltersType, GetLifeStyleStores, HasPermission, ViewQuotesSharePermission } from '@utils';

import {
  EmptyFilterMessage,
  EmptySearchMessage,
  FilterCheckbox,
  FilterStars,
  SearchPropertyName,
  SkeletonContent,
  WhiteButton,
  SkeletonMap,
  ExpiredSessionModal,
  Banner,
  WalletSearchSlider,
  WalletNextRewardCard,
  SkeletonFilters,
  FilterBox,
} from '@components';
import { BlueButton, CustomErrorPage, CustomSelect } from '@share/components';
import {
  filtersActions,
  resetHotels,
  resetHotelsFull,
  getHotels,
  getSimilarHotels,
  getMapHotels,
  hotelsActions,
  IDatesState,
  IFiltersState,
  IHotelsState,
  ILocationsState,
  IRoomsState,
  locationActions,
  ILoginState,
  loginActions,
  getUserWallet,
  ISavedPropertiesState,
  HotelsFilterType,
  VACATIONS_FILTERED,
  IFilterType,
  getSimilarHotelsNearBy,
} from '@share/store/slices';
import { CloseBlueSvg, FilterSvg, MapSvg, MapSearchBlueSvg, MapSearchSvg } from '@assets';
import { CloseSvg } from '@share/assets';
import { getAccountUsernameFromPath, RootState, getSelectedCurrency, VACATIONS_PAGE, GetHomeParams, isAllInclusiveFromQuery, GetMultipleCitiesEnabled, getDateOnly } from '@share/utils';

import {
  IAccount,
  IBounds,
  IBudgetRange,
  IClientCash,
  ICounterItem,
  ICounters,
  IHotel,
  ILocation,
  IRoom,
  ISessionKey,
  IUser,
  LocationsTypes,
  SEARCH_BANNER_TYPE,
  IShareCompareState,
} from '@share/common-types';
import MapImage from '@assets/images/map.png';
import MapMonoImage from '@assets/images/map_mono.png';
import {
  APP_SELECTOR,
  NULL_VALUE,
  TOP_AMENITIES_ICONS,
} from '@constants';
import {
  FILTERS_LABEL,
  getPropertyTypeCodeByValue,
  getRefundabilityCodeByValue,
  getSortByCodeByValue,
  HomesTypes,
  MAIN_BLUE_COLOR,
  Routes,
  R_FILTER_BUDGET,
  R_FILTER_CONDO,
  R_FILTER_NAME,
  R_FILTER_STARS,
  R_VIEW_MAP,
  SortTypes,
  LIFE_STYLE_NAME_PARAM,
  DEFAULT_MEDIA_POINT,
  DEAL_HOME_LABEL,
  ALL_INCLUSIVE_KEY,
  ALL_INCLUSIVE_VALUE,
} from '@share/constants';
import {
  getAmenities,
  isFiltersChanged,
  isFiltersEmpty,
  Map,
  getSortOptions
} from '@utils';
import {
  Responsive,
  UrlUtils,
  isDataValid,
  getHomesOptions
} from '@share/utils';
import { HotelCardComponent } from '../hotel-card';
import { MapWrapper } from '../../map';
import { ModalCompare } from './modal-compare';

import { RouteComponentProps, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faList, faSliders } from '@fortawesome/free-solid-svg-icons';

import './style.scss';
import { SelectedFiltersHeader } from '../selected-filters-header';
import { SelectedFiltersFooter } from '../selected-filters-footer';
import { compareActions } from '@share/store/slices';

interface IMapStateToProps {
  hotelsStore: IHotelsState;
  datesStore: IDatesState;
  locationsStore: ILocationsState;
  roomsStore: IRoomsState;
  filtersStore: IFiltersState;
  loginStore: ILoginState;
  savedPropertiesStore: ISavedPropertiesState;
  sharecompareStore: IShareCompareState;
}

interface IMapDispatchToProps {
  setPageNumber: () => void;
  getUserWallet: (user: IUser) => void;
  getHotels: (
    location: ILocation,
    isLoadMore: boolean,
    isFiltersChange: boolean,
  ) => void;
  getSimilarHotels: (isFiltersChange: boolean, isLoadMore: boolean) => void;
  resetHotels: (isFiltersChange?: boolean) => void;
  getSimilarHotelsNearBy: (isFiltersChange: boolean, isLoadMore: boolean) => void;
  resetHotelsFull: () => void;
  setLoadingFilter: (loadingFilter: boolean) => void;
  setBudget: (value: string[]) => void;
  setMapLoading: (isMapLoading: boolean) => void;
  setAmenities: (value: string[]) => void;
  setAccommodationType: (value: string[]) => void;
  setAccessibility: (value: string[]) => void;
  setPopularLocations: (value: string[]) => void;
  setBoardName: (value: string[]) => void;
  setRefundable: (value: string[]) => void;
  setFlexibleDate: (value: string[]) => void;
  setNeighbourhoods: (value: string[]) => void;
  setPlaces: (value: string[]) => void;
  setStarRating: (value: number[]) => void;
  setSortBy: (value: string) => void;
  setSelectedCompareHotels: (selectedCompareHotels: IHotel[]) => void;
  resetFiltersByType: (filterType: IFilterType, isQuickEnabled: boolean) => void;
  getMapHotels: (
    location: ILocation,
    startDate: string | null | undefined,
    endDate: string | null | undefined,
    rooms: IRoom[],
    hotelId?: number,
  ) => void;
  validateLocation: (error: string) => void;
  setBounds: (bounds: IBounds) => void;
  setIsMapView: (isMapView: boolean) => void;
  setSearchHomes: (value: string) => void;
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => void;
  setLifeStyle: (value: string) => void;
  setHotelToCompare: (sharecompare: IHotel[]) => void;
  setHotelCompareStartDate: (value: string) => void;
  setHotelCompareEndDate: (value: string) => void;
  setclearHotelsCompare: () => void;
  setFilters: (filters: IFiltersState) => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps, WrappedComponentProps, RouteComponentProps {
  label: string;
  isVacationRentals: boolean | null | undefined;
  matches?: boolean;
}

interface IState {
  isFullAmenities: boolean;
  isFullNeighbourhoods: boolean;
  isFullAccessibilities: boolean;
  isFullPopularLocations: boolean;
  isFullAccommodationTypes: boolean;
  isFullMealPlans: boolean;
  isMobileFilter: boolean;
  isMapView: boolean;
  showFilters: boolean;
  selectedHotel: IHotel;
  showCompareModal: boolean;
  backHomeType: string;
}

const debounceTime = 150;
const scrollPixels = 450;
const zero = 0;
const maxCompareHotels = 5;
const maxAmenitiesCount = 6;

class ResultWrapperComponent extends React.Component<IProps, IState> {
  state: IState = {
    isFullAmenities: false,
    isFullNeighbourhoods: false,
    isFullAccessibilities: false,
    isFullPopularLocations: false,
    isFullAccommodationTypes: false,
    isFullMealPlans: false,
    isMobileFilter: false,
    isMapView: false,
    showFilters: true,
    selectedHotel: NULL_VALUE,
    showCompareModal: false,
    backHomeType: NULL_VALUE,
  };

  root: HTMLDivElement | null = document.querySelector(APP_SELECTOR);
  prevFilters: IFiltersState = this.props.filtersStore;
  wrapperRef: React.RefObject<HTMLDivElement> = React.createRef();
  filterButtonWrapperRef: React.RefObject<HTMLDivElement> = React.createRef();

  mergeCounters = (counters: ICounters | null | undefined, similarCounters: ICounters | null | undefined): ICounters | null | undefined => {
    if (!counters && !similarCounters) {
      return NULL_VALUE;
    }

    if (!counters) {
      return similarCounters;
    }

    if (!similarCounters) {
      return counters;
    }

    // Helper function to merge ICounterItem arrays
    const mergeCounterItems = (items1: ICounterItem[], items2: ICounterItem[]): ICounterItem[] => {
      const mergedMap: { [key: string]: number } = {};
      
      // Add items from first array
      items1.forEach(item => {
        mergedMap[item.key] = (mergedMap[item.key] || 0) + item.count;
      });
      
      // Add items from second array
      items2.forEach(item => {
        mergedMap[item.key] = (mergedMap[item.key] || 0) + item.count;
      });
      
      // Convert back to array
      return Object.entries(mergedMap).map(([key, count]) => ({ key, count }));
    };

    // Helper function to merge IBudgetRange arrays
    const mergeBudgetRanges = (ranges1: IBudgetRange[], ranges2: IBudgetRange[]): IBudgetRange[] => {
      const mergedMap: { [key: string]: number } = {};
      
      // Add ranges from first array
      ranges1.forEach(range => {
        const key = `${range.key.from}-${range.key.to}`;
        mergedMap[key] = (mergedMap[key] || 0) + range.count;
      });
      
      // Add ranges from second array
      ranges2.forEach(range => {
        const key = `${range.key.from}-${range.key.to}`;
        mergedMap[key] = (mergedMap[key] || 0) + range.count;
      });
      
      // Convert back to array
      return Object.entries(mergedMap).map(([key, count]) => {
        const [from, to] = key.split('-');
        return {
          key: {
            from: from === 'null' ? null : Number(from),
            to: to === 'null' ? null : Number(to)
          },
          count
        };
      });
    };

    return {
      amenities: mergeCounterItems(counters.amenities || [], similarCounters.amenities || []),
      accessibilities: mergeCounterItems(counters.accessibilities || [], similarCounters.accessibilities || []),
      popularLocations: mergeCounterItems(counters.popularLocations || [], similarCounters.popularLocations || []),
      budgetRanges: mergeBudgetRanges(counters.budgetRanges || [], similarCounters.budgetRanges || []),
      propertyTypes: mergeCounterItems(counters.propertyTypes || [], similarCounters.propertyTypes || []),
      boardNames: mergeCounterItems(counters.boardNames || [], similarCounters.boardNames || []),
      neighbourhoods: mergeCounterItems(counters.neighbourhoods || [], similarCounters.neighbourhoods || []),
      refundable: mergeCounterItems(counters.refundable || [], similarCounters.refundable || []),
      starRating: mergeCounterItems(counters.starRating || [], similarCounters.starRating || []),
      totalFlexibleDates: (counters.totalFlexibleDates || 0) + (similarCounters.totalFlexibleDates || 0),
      totalHotels: (counters.totalHotels || 0) + (similarCounters.totalHotels || 0),
      totalFilteredHotels: (counters.totalFilteredHotels || 0) + (similarCounters.totalFilteredHotels || 0),
      totalNights: (counters.totalNights || 0) + (similarCounters.totalNights || 0),
    };
  };

  checkIsLocationValid = (): boolean => {
    const { datesStore, locationsStore, validateLocation, intl } = this.props;
    const { isLocationValid } = isDataValid(locationsStore, datesStore);

    if (!isLocationValid) {
      validateLocation(intl.formatMessage({ id: 'location.error' }));
      return false;
    }

    return true;
  };

  onScroll = debounce(() => {
    const {
      setPageNumber,
      getHotels,
      getSimilarHotels,
      getSimilarHotelsNearBy,
      loginStore,
      locationsStore,
      hotelsStore,
    } = this.props;
    const { account } = loginStore;
    const { loadingMore, hotels, similarHotels, prevHotels, isSessionExpired, lastSearchedLocation } = hotelsStore;
    const { selectedLocation, location } = locationsStore;

    if (!lastSearchedLocation && !selectedLocation) {
      this.checkIsLocationValid();
    }

    const rootHeightCheck = this.root?.scrollHeight ? this.root.scrollHeight : this.root?.offsetHeight;
    const rootHeight = rootHeightCheck ? rootHeightCheck : 0;
    if (!this.state.isMapView &&
        !isSessionExpired &&
        !loadingMore &&
        this.root &&
        window.innerHeight + window.scrollY + scrollPixels >= rootHeight
    ) {
      setPageNumber();
      const total = hotelsStore?.counters?.totalFilteredHotels || 0;
      const loaded = hotels.length;
      const hasMore = loaded < total;

      const totalSimilar = hotelsStore?.similarCounters?.totalFilteredHotels || 0;
      const loadedSimilar = similarHotels.length;
      const hasMoreSimilar = loadedSimilar < totalSimilar;
      if (hotels &&
          hotels.length &&
          hasMore &&
          prevHotels.length) {
        getHotels(
          lastSearchedLocation,
          true,
          false,
        );
      } else if (location?.type === 'Hotel' &&
                 similarHotels &&
                 similarHotels.length &&
                 hasMoreSimilar) {
        getSimilarHotels(false, true);
      } else if (location?.type !== 'Hotel' &&
                 similarHotels &&
                 similarHotels.length &&
                 hasMoreSimilar &&
                 !account?.disableNearbyResults) {
        getSimilarHotelsNearBy(false, true);
      }

      
    }
  }, debounceTime);

  componentDidMount() {
    window.history.pushState(null, NULL_VALUE, window.location.pathname + window.location.search);
    window.addEventListener('popstate', this.onClickBackButton);
    window.addEventListener('scroll', this.onScroll); 

    document.addEventListener('mousedown', this.handleClickOutside);

    const values = UrlUtils.getValues();
    if (values[DEAL_HOME_LABEL]) {
      this.setState({ backHomeType: values[DEAL_HOME_LABEL] as string });
    }
    const{sharecompareStore , roomsStore,datesStore}=this.props;
    const { roomsSelected, rooms } = roomsStore;
    const isSame = JSON.stringify(roomsSelected) === JSON.stringify(rooms);
    const {hotelCompareStartDate ,hotelCompareEndDate}= sharecompareStore;
    const { startDateSelected, endDateSelected } = datesStore;
    const hasMultipleCities= GetMultipleCitiesEnabled(this.props.loginStore);

    if(hasMultipleCities){
      if (!isSame) {
        this.props.setclearHotelsCompare();
      } 
      if(getDateOnly(startDateSelected) !== getDateOnly(hotelCompareStartDate)){
        this.props.setHotelCompareStartDate(getDateOnly(startDateSelected));
        this.props.setclearHotelsCompare();
      }
      if(getDateOnly(endDateSelected) !== getDateOnly(hotelCompareEndDate)){
        this.props.setHotelCompareEndDate(getDateOnly(endDateSelected));
        this.props.setclearHotelsCompare();
      }
    }else{
      this.props.setclearHotelsCompare();
    }
   
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('popstate', this.onClickBackButton);

    document.removeEventListener('mousedown', this.handleClickOutside);

    const footer: HTMLDivElement | null = document.querySelector('.footer');

    if (footer) {
      document.body.style.overflow = 'auto';
      footer.style.display = 'block';
    }
  }

  handleClickOutside = (event: any) => {
    if (this.state.isMapView && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) &&
        this.filterButtonWrapperRef.current && !this.filterButtonWrapperRef.current.contains(event.target)) {
      this.setState({ showFilters: false });
    }
  }

  onClickBackButton = (e: any) => {
    e.preventDefault();

    const accountName = getAccountUsernameFromPath(this.props.history);

    const { loginStore } = this.props;
    const { account } = loginStore;

    const homeParams = GetHomeParams(account as IAccount);

    if (this.props.isVacationRentals) {
      this.props.history.push(`/${accountName}${Routes.Search}/${VACATIONS_PAGE}${homeParams}`);
    } else {
      this.props.history.push(`/${accountName}${Routes.Search}${homeParams}`);
    }

    window.location.reload();
  }

  onBudgetChange = (checkedValues: string[]) => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    this.props.setBudget(checkedValues);

    ReactGA.event({
      category: account?.name as string,
      action: `${R_FILTER_BUDGET}_${account?.name.toUpperCase()}`,
      label: `User selected budget checkbox filter on result`,
      nonInteraction: false,
    });

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onAmenitiesChange = (checkedValues: string[]) => {
    this.props.setAmenities(checkedValues);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onAccommodationTypeChange = (checkedValues: string[]) => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    const restrictedVacationRentals = account?.restrictedVacationRentals;
    const restrictedVacationRentalsList = account?.restrictedVacationRentalsList;
    const accomodationTypes = restrictedVacationRentalsList?.length ? restrictedVacationRentalsList : VACATIONS_FILTERED;
    const values = (restrictedVacationRentals && !checkedValues?.length) ? accomodationTypes : checkedValues;

    this.props.setAccommodationType(values);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onAccessibilityChange = (checkedValues: string[]) => {
    this.props.setAccessibility(checkedValues);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onPopularLocationChange = (checkedValues: string[]) => {
    this.props.setPopularLocations(checkedValues);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onBoardNameChange = (checkedValues: string[]) => {
    this.props.setBoardName(checkedValues);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onRefundableChange = (checkedValues: string[]) => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    this.props.setRefundable(checkedValues);

    const action = getRefundabilityCodeByValue(checkedValues);
    ReactGA.event({
      category: account?.name as string,
      action: `${action}_${account?.name.toUpperCase()}`,
      label: `User selected ${action} checkbox filter on result`,
      nonInteraction: false,
    });

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onFlexibleDatesChange = (checkedValues: string[]) => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    this.props.setFlexibleDate(checkedValues);

    ReactGA.event({
      category: account?.name as string,
      action: `${R_FILTER_CONDO}_${account?.name.toUpperCase()}`,
      label: `User selected/unselected stay more save more checkbox filter on result`,
      nonInteraction: false,
    });

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onNeighborhoodsChange = (checkedValues: string[]) => {
    this.props.setNeighbourhoods(checkedValues);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  toggleAmenities = () => {
    this.setState(({ isFullAmenities }) => ({
      isFullAmenities: !isFullAmenities,
    }));
  };

  toggleNeighbourhoods = () => {
    this.setState(({ isFullNeighbourhoods }) => ({
      isFullNeighbourhoods: !isFullNeighbourhoods,
    }));
  };

  getSortOptions = (): LabeledValue[] => {
    const { loginStore, hotelsStore } = this.props;
    const { account } = loginStore;
    const hasQuick = account?.hasQuick;
    const isB2C = account?.isB2C;
    const walletWalletSavings = account?.walletWalletSavings;
    const hasSavedProperties = hotelsStore.hotels.some(x => x.savedProperty);
    const isSaverRuleProfits = account?.isSaverRuleProfits;
    const isCustomerAgent = account?.isCustomerAgent;
  
    const displayRecommended = !!isSaverRuleProfits;
    const displayRecommendedCustomerAgent = !!isCustomerAgent;

    return getSortOptions(hasQuick as boolean, isB2C as boolean, walletWalletSavings as boolean, displayRecommended, displayRecommendedCustomerAgent, hasSavedProperties);
  };

  onSearchSave = () => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    ReactGA.event({
      category: account?.name as string,
      action: `${R_FILTER_NAME}_${account?.name.toUpperCase()}`,
      label: `User selected an hotel name filter on resuls`,
      nonInteraction: false,
    });

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onStarsChange = (value: number[]) => {
    this.props.setStarRating(value);

    const { loginStore } = this.props;
    const { account } = loginStore;

    ReactGA.event({
      category: account?.name as string,
      action: `${R_FILTER_STARS}_${account?.name.toUpperCase()}`,
      label: `User selected stars filter on resuls`,
      nonInteraction: false,
    });

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };


  onSortChange = (value: SelectValue) => {
    const valueStr = value as string;
    this.props.setSortBy(valueStr);

    const { loginStore } = this.props;
    const { account } = loginStore;

    const action = getSortByCodeByValue(valueStr);
    if (action) {
      ReactGA.event({
        category: account?.name as string,
        action: `${action}_${account?.name.toUpperCase()}`,
        label: `User selected ${action} sort on result`,
        nonInteraction: false,
      });
    }

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onLifeStyleChange = (value: SelectValue) => {
    const valueStr = value as string;
    this.props.setLifeStyle(valueStr);

    UrlUtils.removeFromUrl(LIFE_STYLE_NAME_PARAM);
    UrlUtils.setUrl(LIFE_STYLE_NAME_PARAM, valueStr);

    return !this.state.isMobileFilter && this.onFiltersOrSortChange(true);
  };

  onResetFilters = (fromMap = false) => {
    const { loginStore, isVacationRentals } = this.props;
    const { account } = loginStore;

    UrlUtils.setUrl(FILTERS_LABEL, null);

    if (fromMap) {
      this.props.setMapLoading(fromMap);
    }

    const restrictedVacationRentalsList = account?.restrictedVacationRentalsList;
    let type = getHotelsFiltersType(account as IAccount, isVacationRentals);
    if (isAllInclusiveFromQuery()) {
      type = HotelsFilterType.AllInclusive;
    }

    this.props.resetFiltersByType({ type, list: restrictedVacationRentalsList }, account?.hasQuick || false);
    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  onFiltersOrSortChange = (isStoreChange?: boolean) => {
    this.onFiltersOrSortChangeDebounce(isStoreChange);
  };

  onFiltersOrSortChangeDebounce = debounce((isStoreChange?: boolean) => {
    const {
      getHotels,
      locationsStore,
      filtersStore,
      hotelsStore,
      loginStore,
      resetHotels,
      getUserWallet,
    } = this.props;
    const { lastSearchedLocation } = hotelsStore;
    const { selectedLocation } = locationsStore;

    if (!lastSearchedLocation && !selectedLocation) {
      this.checkIsLocationValid();
    }

    if (isFiltersChanged(this.prevFilters, filtersStore)) {
      this.props.setLoadingFilter(true);
      UrlUtils.setUrl(FILTERS_LABEL, filtersStore);
      this.prevFilters = filtersStore;
      getHotels(
        lastSearchedLocation,
        true,
        true,
      );
    } else if (isStoreChange) {
      const { user } = loginStore;

      resetHotels();
      getUserWallet(user as IUser);
      getHotels(
        lastSearchedLocation,
        false,
        false,
      );
    }
  }, debounceTime);

  onMobileFilter = () => {
    if (!this.props.hotelsStore.isSessionExpired) {
      this.setState({ isMobileFilter: !this.state.isMobileFilter });
      return this.state.isMobileFilter
        ? (document.body.style.overflow = 'auto')
        : (document.body.style.overflow = 'hidden');
    }
  };

  onApply = () => {
    this.onMobileFilter();
    this.onFiltersOrSortChange();
  };

  showMap = (_center: google.maps.LatLngLiteral, selectedHotel: IHotel = NULL_VALUE): void => {
    const { hotelsStore, loginStore } = this.props;
    const { hotels, similarHotels } = hotelsStore;
    const { account } = loginStore;

    if (!this.props.hotelsStore.isSessionExpired && (hotels?.length || similarHotels?.length)) {
      this.setState({ showFilters: false });

      const footer: HTMLDivElement | null = document.querySelector('.footer');

      this.setState({ isMapView: true, selectedHotel });
      this.props.setIsMapView(true);
      this.onMapSearchUpdate(selectedHotel);

      if (footer) {
        window.scrollTo(zero, zero);
        document.body.style.overflow = 'hidden';
        footer.style.display = 'none';
      }
    }

    ReactGA.event({
      category: account?.name as string,
      action: `${R_VIEW_MAP}_${account?.name.toUpperCase()}`,
      label: `User clicked view map`,
      nonInteraction: false,
    });

  };

  showFiltersView = () => {
    this.setState({ showFilters: !this.state.showFilters });
  }

  showListView = (): void => {
    if (!this.props.hotelsStore.isSessionExpired) {
      this.setState({ showFilters: true });

      const footer: HTMLDivElement | null = document.querySelector('.footer');

      this.setState({ isMapView: false });
      this.props.setIsMapView(false);

      if (footer) {
        document.body.style.overflow = 'auto';
        footer.style.display = 'block';
      }
    }
  };

  onMapSearchUpdate = (selectedHotel: IHotel = NULL_VALUE): void => {
    if (!this.props.hotelsStore.isSessionExpired) {
      const { getMapHotels, datesStore, roomsStore, locationsStore } = this.props;
      const { location } = locationsStore;
      const { startDate, endDate } = datesStore;
      const { rooms } = roomsStore;

      getMapHotels(location || NULL_VALUE, startDate, endDate, rooms, selectedHotel?.hotelId);
    }
  };

  getMapHotelList = (location: ILocation, mapHotels: IHotel[], similarHotels: IHotel[]): IHotel[] => {
    if (location.type === 'Hotel') {
      const list: IHotel[] | null = (mapHotels?.length || similarHotels?.length) ? [] : null;
    
      if (mapHotels?.length) {
        mapHotels.forEach(h => list?.push(h));
      }
      if (similarHotels?.length) {
        similarHotels.forEach(h => list?.push(h));
      }

      return list as IHotel[];
    }

    return NULL_VALUE;
  }

  handleSearchHomes = (value: SelectValue) => {
    const valueStr = value as string;
    this.props.setSearchHomes(valueStr);

    const action = getPropertyTypeCodeByValue(valueStr);
    if (action) {

      const { loginStore } = this.props;
      const { account } = loginStore;

      ReactGA.event({
        category: account?.name as string,
        action: `${action}_${account?.name.toUpperCase()}`,
        label: `User clicked ${value === HomesTypes.HotelOnly ? 'Hotel' : 'Vacation rental'} button on result`,
        nonInteraction: false,
      });
    }

    return !this.state.isMobileFilter && this.onFiltersOrSortChange();
  };

  homesFilterComponent = () => {
    const { loginStore, filtersStore, hotelsStore, locationsStore, isVacationRentals } = this.props;

    const { hotels, similarHotels, loadingQuick } = hotelsStore;
    const { location } = locationsStore;

    const account = loginStore?.account;
    const color: any = account?.buttonColor ? account?.buttonColor : MAIN_BLUE_COLOR;
    const buttonBorderRadius: any = account?.buttonBorderRadius ? account?.buttonBorderRadius : null;

    const styleButtonBorderRadius = !isEmpty(buttonBorderRadius) ? { borderRadius: buttonBorderRadius } : {};  
    const styleColor = !isEmpty(color) ? { ...styleButtonBorderRadius, background: color, borderRightColor: color, borderColor: color } : { ...styleButtonBorderRadius };  
    
    const isEmptySearch = (hotels && !hotels.length && location?.type !== 'Hotel') || 
                          (hotels && !hotels.length && similarHotels && !similarHotels.length && location?.type === 'Hotel');

    if(isVacationRentals || account?.forceDisableVacationRentals || account?.isSundance || isEmptySearch) {
      return null;
    }

    return (
      <div className="row row-cols-6 pb-3 result-wrapper__style-home-search-container">
        <div className="col-12">
          <Radio.Group value={filtersStore.searchHomes} optionType="button" buttonStyle="solid" size="large" onChange={(e) => this.handleSearchHomes(e.target.value)}>
            {getHomesOptions(false).map((item, index) => (
              <Radio.Button 
                key={`${index}-${item}`}
                value={item.value}
                className="result-wrapper__style-home-search"
                style={item.value === filtersStore.searchHomes ? styleColor : { ...styleButtonBorderRadius }}
                disabled={loadingQuick}
              >
                {item.icon} {item.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </div>
      </div>
    )
  }

  handleCompare = (hotel: IHotel) => {
    const { sharecompareStore } = this.props;
    const { hotelcompare } = sharecompareStore;
    const hotelIndex = hotelcompare.findIndex(h => h.hotelId === hotel.hotelId);
    if (hotelIndex != -1) {
      const updatedHotelCompare = hotelcompare.filter(h => h.hotelId !== hotel.hotelId);
      this.props.setHotelToCompare(updatedHotelCompare);
    } else {
      this.props.setHotelToCompare([...hotelcompare, hotel]);
    }
  }

  handleOnSelectClientCash = (selectedSearchClientCash: number | null | undefined) => {
    const { hotelsStore } = this.props;
    const { selectedHotelSearchClientCash } = hotelsStore;

    const clientCash = { ...selectedHotelSearchClientCash, selectedSearchClientCash };
    this.props.setSelectedHotelSearchClientCash(clientCash);
  }

  renderBack = () => {
    const { backHomeType } = this.state;
    const { loginStore, history, isVacationRentals } = this.props;
    const { account } = loginStore;

    const isDisableHomes = account?.isDisableHomes;

    if (isDisableHomes) {
      return null;
    }

    const accountName = getAccountUsernameFromPath(history);
    const homeParams = GetHomeParams(account as IAccount);
    const isAllInclusive = backHomeType === ALL_INCLUSIVE_KEY;

    return (
      <div className="back-home" onClick={() => {
        this.props.resetHotelsFull();
        if (isAllInclusive) {
          this.props.history.push(`/${accountName}${Routes.AllInclusive}`);
        } else if (isVacationRentals) {
          this.props.history.push(`/${accountName}${Routes.Search}/${VACATIONS_PAGE}${homeParams}`);
        } else {
          this.props.history.push(`/${accountName}${Routes.Search}${homeParams}`);
        }
      }}>
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '5px' }} /> <FormattedMessage id={isAllInclusive ? 'back.to.all_inclusive' : 'back.home'} />
      </div>)
  }

  render(): React.ReactNode {
    const { isFullAmenities, isMobileFilter, isMapView, showFilters, selectedHotel, isFullNeighbourhoods, isFullAccessibilities, isFullPopularLocations, isFullAccommodationTypes, isFullMealPlans, showCompareModal, backHomeType } = this.state;
    const { hotelsStore, loginStore, filtersStore, locationsStore, roomsStore, datesStore, matches, isVacationRentals, setBounds ,sharecompareStore } = this.props;
    const {
      hotels,
      similarHotels,
      searchedLocation,
      lastSearchedLocation,
      loadingMore,
      loadingSimilar,
      counters,
      filterCounters,
      similarCounters,
      mapCounters,
      loadingFilter,
      mapHotels,
      bounds,
      boundsSimilar,
      isSessionExpired,
      mapLoading,
      sessionKey,
      error,
      selectedHotelSearchClientCash,
      loading,
      loadingQuick
    } = hotelsStore;

    const {
      amenities,
      accommodationType,
      accessibility,
      budget,
      popularLocations,
      neighbourhoods,
      propertyName,
      sortBy,
      starRatings,
      refundable,
      boardNames,
      flexibleDates,
      searchHomes,
    } = filtersStore;
    const { account, user, lifeStyle } = loginStore;
    const { location } = locationsStore;
    const { startDate, endDate } = datesStore;
    const { rooms } = roomsStore;
    const { hotelcompare }= sharecompareStore;
    const countersMergeSearch = filterCounters ? { ...filterCounters } : counters;
    const countersMerge = this.mergeCounters(hotels?.length ? countersMergeSearch : null, !!similarHotels?.length ? similarCounters : null);
    const resultCounters = isMapView ? (mapCounters ? mapCounters : countersMerge) : countersMerge;

    const isFiltersApplied = !isFiltersEmpty(filtersStore, account as IAccount, isVacationRentals);
    const isSearchHomesApplied = !isVacationRentals && searchHomes !== HomesTypes.All;
    const HasViewQuotesSharePermission = HasPermission(user as IUser, ViewQuotesSharePermission);
    const displayCompareLength = (HasViewQuotesSharePermission || isFiltersApplied) ? 0 : 1;

    const isAllInclusive = backHomeType === ALL_INCLUSIVE_KEY;

    if (!isEmpty(error)) {
      return (
        <div className={`result-wrapper ${isMapView ? 'map-view' : ''}`}>
          <div className="result-wrapper__back-link">
            {this.renderBack()}
          </div>

          <div className="result-wrapper__wrapper">
            <CustomErrorPage message={error} />
          </div>
        </div>
      );
    }

    let sortedAmenities = NULL_VALUE;
    let amenitiesToShow: ICounterItem[] = NULL_VALUE;
    let neighbourhoodsToShow:ICounterItem[] = NULL_VALUE;
    let accessibilitiesToShow:ICounterItem[] = NULL_VALUE;
    let popularLocationsToShow:ICounterItem[] = NULL_VALUE;
    let accommodationTypesToShow:ICounterItem[] = NULL_VALUE;
    let boardNamesToShow:ICounterItem[] = NULL_VALUE;
    
    let isShowAmenities: boolean = false;
    let isShowNeighbourhoods;
    let isShowBudgets;
    let hasBudgets: boolean = false;
    let isShowAccommodationTypes;
    let isShowRefundable;
    let isShowAccessibility;
    let isShowMealPlans;
    let isShowPopularLocations;

    let isFlexibleDates; 

    if (!!resultCounters) {
      let accessibilities = resultCounters.accessibilities;
      if (accessibilities?.length && accessibility?.length) {
        const accessibilitiesToMoveTop = resultCounters.accessibilities.filter(a => accessibility.includes(a.key));
        const accessibilitiesToKeep = resultCounters.accessibilities.filter(a => !accessibility.includes(a.key));
        accessibilities = [...accessibilitiesToMoveTop, ...accessibilitiesToKeep];
      }

      let accommodationTypes = resultCounters.propertyTypes;
      if (accommodationTypes?.length && accommodationType?.length) {
        const accommodationTypesToMoveTop = resultCounters.propertyTypes.filter(a => accommodationType.includes(a.key));
        const accommodationTypesToKeep = resultCounters.propertyTypes.filter(a => !accommodationType.includes(a.key));
        accommodationTypes = [...accommodationTypesToMoveTop, ...accommodationTypesToKeep];

        if (account?.forceDisableVacationRentals) {
          const ACCOMMODATIONS_TO_EXCLUDE = ['Apartment', 'Condominium', 'Villas', 'Private vacation home'];
          accommodationTypes = accommodationTypes.filter(a => !ACCOMMODATIONS_TO_EXCLUDE.includes(a?.key));
        }
      }

      let mealPlans = resultCounters.boardNames;
      if (mealPlans?.length && boardNames?.length) {
        const mealPlansToMoveTop = resultCounters.boardNames.filter(a => boardNames.includes(a.key));
        const mealPlansToKeep = resultCounters.boardNames.filter(a => !boardNames.includes(a.key));
        mealPlans = [...mealPlansToMoveTop, ...mealPlansToKeep];
      }

      sortedAmenities = getAmenities(resultCounters.amenities);
      amenitiesToShow = isFullAmenities ? sortedAmenities : sortedAmenities.slice(zero, maxAmenitiesCount);
      neighbourhoodsToShow = isFullNeighbourhoods ? resultCounters.neighbourhoods : resultCounters.neighbourhoods.slice(zero, maxAmenitiesCount);
      accessibilitiesToShow = isFullAccessibilities ? accessibilities : accessibilities.slice(zero, maxAmenitiesCount);
      accommodationTypesToShow = isFullAccommodationTypes ? accommodationTypes : accommodationTypes.slice(zero, maxAmenitiesCount);
      boardNamesToShow = isFullMealPlans ? mealPlans : mealPlans.slice(zero, maxAmenitiesCount);

      isShowAmenities = !!amenitiesToShow.filter(({ count }) => !!count).length;
      isShowNeighbourhoods = !!resultCounters.neighbourhoods.filter(({ count }) => !!count).length;
      isShowBudgets = !!budget?.length || !!resultCounters.budgetRanges.filter(({ count }) => !!count).length;
      hasBudgets = !!resultCounters.budgetRanges.filter(({ count }) => !!count).length;
      isShowAccommodationTypes = !!resultCounters.propertyTypes.filter(({ count }) => !!count).length;
      isShowRefundable = !!resultCounters.refundable.filter(({ count }) => !!count).length;
      isFlexibleDates = !!resultCounters.totalFlexibleDates;
      isShowAccessibility = !!resultCounters.accessibilities.filter(({ count }) => !!count).length;
      isShowMealPlans = !!resultCounters.boardNames.filter(({ count }) => !!count).length;

      if (isAllInclusiveFromQuery()) {
        isShowMealPlans = !resultCounters.boardNames.some((boardName) => boardName.key === ALL_INCLUSIVE_VALUE);
      }
    }

    const currentFilters = [
      amenities,
      accommodationType,
      budget,
      neighbourhoods,
      propertyName,
      starRatings,
      refundable,
      boardNames,
      flexibleDates,
    ];

    const isB2C = account?.isB2C;
    const walletWalletSavings = account?.walletWalletSavings;
    const forceDisableVacationRentals = account?.forceDisableVacationRentals;
    const restrictedVacationRentals = account?.restrictedVacationRentals;
    const restrictedVacationRentalsList = account?.restrictedVacationRentalsList;
    const isSaverRuleProfits = account?.isSaverRuleProfits;
    const isCustomerAgent = account?.isCustomerAgent;
    const isSundance = account?.isSundance;
  
    const initialSort = isSundance ? 
                            SortTypes.BiggestSavingsPercentage : 
                            isSaverRuleProfits ?
                                SortTypes.BiggestSavingsPercentage :
                                isCustomerAgent ?
                                    SortTypes.BiggestSavingsPercentage :
                                    (!isB2C || walletWalletSavings) ? 
                                        isVacationRentals ?
                                            restrictedVacationRentals ?
                                                restrictedVacationRentalsList?.length ? SortTypes.BiggestSavingsPercentage : SortTypes.BiggestSavingsPercentage : 
                                                SortTypes.BiggestSavingsPercentage :
                                            SortTypes.BiggestSavingsPercentage : 
                                        forceDisableVacationRentals ? 
                                            SortTypes.GuestRating : 
                                            isVacationRentals ?
                                                restrictedVacationRentals ?
                                                    restrictedVacationRentalsList?.length ? SortTypes.GuestRating : SortTypes.GuestRating : 
                                                    SortTypes.GuestRating :
                                                SortTypes.GuestRating;

    if (sortBy !== initialSort) {
      currentFilters.push(sortBy);
    }

    const applyFilters = currentFilters.filter(String);
    
    const currency = getSelectedCurrency(account as IAccount);
    const mapHotelsStore = mapHotels ? mapHotels : [];
    const similarHotelsStore = similarHotels ? similarHotels : [];
    const mapHotelsList = [...mapHotelsStore, ...similarHotelsStore];
    const isEmptySearch = (hotels && !hotels.length && location?.type !== 'Hotel') || (hotels && !hotels.length && similarHotels && !similarHotels.length);
    const isCapital = account?.isCapitalVacations;
    const isCapitalAgent = account?.isCapitalVacationsAgent;

    const walletHasSliderOnSearch = account?.walletHasSliderOnSearch;
    const hasClientCash = account?.hasClientCash;
    const isNewTemplate = account?.isNewTemplate;
    const background = account ? account?.buttonColor : null;
    const generalBorderColor = account ? account?.generalBorderColor : null;
    const generalBorderRadius = account ? account?.generalBorderRadius : null;
    const buttonBorderRadius = account ? account?.buttonBorderRadius : null;
    const enableMinProfit = account?.enableMinProfit;
    const minProfit = account?.minProfit;

    const stylesButtonRadius: any = !isEmpty(buttonBorderRadius) ? { borderRadius: `${buttonBorderRadius}px` } : {};  
    const styleColor = (background && (hotels?.length || similarHotels?.length) && !isEmpty(background))? { ...stylesButtonRadius, background } : { ...stylesButtonRadius };  
       
    const isMobile = document.body.offsetWidth <= DEFAULT_MEDIA_POINT;

    const isMinProfit = enableMinProfit && !!minProfit && minProfit >= 0;

    const stylesRadius: any = !isEmpty(generalBorderRadius) ? { borderRadius: `${generalBorderRadius}px` } : {};  
    const stylesMapImage: any = !isEmpty(generalBorderColor) ? { ...stylesRadius , borderColor: generalBorderColor } : { ...stylesRadius };  

    const totalFilteredHotels = (hotels?.length ? countersMergeSearch?.totalFilteredHotels : 0) || 0;
    const totalFilteredHotelsSimilar = (similarHotels?.length ? similarCounters?.totalFilteredHotels : 0) || 0;
    const totalFilteredHotelsTotal = totalFilteredHotels + totalFilteredHotelsSimilar;

    const oneStar = resultCounters?.starRating?.find(({ key }) => key?.split(' ')[0] === '1');
    const twoStar = resultCounters?.starRating?.find(({ key }) => key?.split(' ')[0] === '2');
    const threeStar = resultCounters?.starRating?.find(({ key }) => key?.split(' ')[0] === '3');
    const fourStar = resultCounters?.starRating?.find(({ key }) => key?.split(' ')[0] === '4');
    const fiveStar = resultCounters?.starRating?.find(({ key }) => key?.split(' ')[0] === '5');

    const plainOptionsStar = [
      { value: 1, count: oneStar?.count || 0, disabled: oneStar?.disabled || false },
      { value: 2, count: twoStar?.count || 0, disabled: twoStar?.disabled || false },
      { value: 3, count: threeStar?.count || 0, disabled: threeStar?.disabled || false },
      { value: 4, count: fourStar?.count || 0, disabled: fourStar?.disabled || false },
      { value: 5, count: fiveStar?.count || 0, disabled: fiveStar?.disabled || false }
    ];

    const displaySelectedFiltersHeader = (!loadingFilter && !loadingMore && !loadingSimilar && !loading && !isEmptySearch && (isFiltersApplied || isSearchHomesApplied));

    return (
      <div className={`result-wrapper ${isMapView ? 'map-view' : ''} ${isNewTemplate ? 'result-wrapper--new-template' : ''}`}>
        
        <div className="result-wrapper__back-link">
          {this.renderBack()}

          {isMapView && (
            <div className="result-wrapper__map-header">
              {location?.type !== 'Hotel' && (<div className="result-wrapper__filters-view-wrapper" ref={this.filterButtonWrapperRef} onClick={this.showFiltersView}>
                <FontAwesomeIcon icon={faSliders} /> <FormattedMessage id="view.filters" />
              </div>)}
              <div className="result-wrapper__list-view-wrapper" onClick={this.showListView}>
                <FontAwesomeIcon icon={faList} /> <FormattedMessage id="view.list" />
              </div>
            </div>)}
        </div>

        <div className="result-wrapper__wrapper">

          {!!resultCounters && !loadingQuick &&
            <div
              className={`result-wrapper__filters-wrapper ${isMobileFilter ? 'is-mobile' : ''} ${
                isSessionExpired ? 'disabled' : ''} ${!showFilters ? 'hite-filters' : ''}`}
              ref={this.wrapperRef}
            >
              {!isMapView && (
                <div
                  className="result-wrapper__map-view-wrapper"
                  onClick={() => this.showMap(Map.getGoogleLocation(location?.geoLocation || { latitude: 0, longitude: 0 }))}
                >
                  <div
                    className={`result-wrapper__map-view ${((hotels?.length || similarHotels?.length) && !loadingFilter) ? '' : 'disabled'}`}
                    style={{ ...stylesMapImage, backgroundImage: `url(${((hotels?.length || similarHotels?.length) && !loadingFilter) ? MapImage : MapMonoImage})` }}
                  >
                    <div className={`result-wrapper__map-button ${((hotels?.length || similarHotels?.length) && !loadingFilter) ? '' : 'disabled'}`} style={styleColor}>
                      {isNewTemplate ? (<MapSearchBlueSvg />) : (<MapSearchSvg />) } <FormattedMessage id="view.on.map" />
                    </div>
                  </div>
                </div>)}

              <div className="result-wrapper__filters-header-wrapper-sticky">
                <div className="result-wrapper__filters-header-wrapper">
                  <div className="result-wrapper__filters-header-item" onClick={this.onMobileFilter}>
                    <CloseBlueSvg />
                    <p className="result-wrapper__filters-header-text">
                      <FormattedMessage id="sort.filter" />
                    </p>
                  </div>
                  {isFiltersApplied && (
                    <p
                      className="result-wrapper__mobile-reset-filters-link"
                      onClick={() => this.onResetFilters()}
                    >
                      <FormattedMessage id="reset.all" />
                    </p>
                  )}
                </div>
                <div
                  className={`result-wrapper__sort-select-wrapper ${
                    isSessionExpired ? 'disabled' : ''
                  }`}
                >
                  {!isNewTemplate && (
                    <span className="result-wrapper__sort-label">
                      <FormattedMessage id="sort.by" />:{' '}
                    </span>)}
                  <div className="result-wrapper__select">
                    <CustomSelect
                      disabled={isSessionExpired || loadingFilter}
                      value={sortBy}
                      onChange={this.onSortChange}
                      options={this.getSortOptions()}
                    />
                  </div>
                </div>

                {location?.type !== LocationsTypes.Hotel &&
                  (!isMapView || (isMapView && !matches)) && (
                    <div className="result-wrapper__filters-search-by-name">
                      <SearchPropertyName
                        disabled={isSessionExpired || (!hotels?.length && !similarHotels?.length) || loadingFilter}
                        className="top-search-wrapper"
                        onSaveValue={this.onSearchSave}
                        title="search.property.name"
                        isMapView={isMapView}
                      />
                    </div>
                  )}

                {isFlexibleDates ? (
                  <div className="result-wrapper__filters-flexible-dates">
                    <div className="result-wrapper__filters-flexible-dates-background"></div>
                    <FilterCheckbox
                      disabled={isSessionExpired || loadingFilter}
                      onChange={this.onFlexibleDatesChange}
                      values={flexibleDates}
                      excludeBorder
                      options={[{
                        count: resultCounters.totalFlexibleDates,
                        value: 'false',
                        label: <span><FormattedMessage id="result.hotel.filters.flexible_dates" /></span>,
                      }]}
                      title="result.hotel.card.stay_more"
                      titleInformation="result.hotel.filters.flexible_dates.title.information"
                    />
                  </div>
                ) : null}

                {isShowRefundable ? (
                  <FilterCheckbox
                    disabled={isSessionExpired || loadingFilter}
                    onChange={this.onRefundableChange}
                    values={refundable}
                    excludeBorder={!isFlexibleDates}
                    options={resultCounters.refundable.map(({ count, key, disabled }) => {
                      return {
                        count,
                        value: key,
                        label: <span>{key}</span>,
                        disabled,
                      };
                    })}
                    title="refundable.type"
                  />
                ) : null}

                <p className="result-wrapper__filters-tittle secondary-font">
                  <FormattedMessage id="filter.by" />
                </p>

                {isShowNeighbourhoods ? (
                  <>
                    <FilterCheckbox
                      disabled={isSessionExpired || loadingFilter}
                      onChange={this.onNeighborhoodsChange}
                      values={neighbourhoods}
                      options={neighbourhoodsToShow?.map(({ count, key, disabled }) => {
                        return {
                          count,
                          value: key,
                          label: <span>{key}</span>,
                          disabled,
                        };
                      })}
                      title="neighborhoods"
                    />
                    {!isSessionExpired && resultCounters.neighbourhoods.length > maxAmenitiesCount && !loadingFilter && (
                      <div className="result-wrapper__show-link" onClick={this.toggleNeighbourhoods}>
                        {isFullNeighbourhoods ? (
                          <FormattedMessage id="show.less" />
                        ) : (
                          <FormattedMessage id="show.more" />
                        )}
                      </div>
                    )}
                  </>
                ) : null}

                {isShowBudgets ? (
                  <FilterCheckbox
                    disabled={isSessionExpired || !hasBudgets || loadingFilter}
                    onChange={this.onBudgetChange}
                    displayZero={!hasBudgets}
                    values={budget}
                    options={resultCounters.budgetRanges.filter(b => !!hasBudgets || budget.includes(`${b.key.from}-${b.key.to}`)).map(({ count, key, disabled }) => {
                      return {
                        count,
                        value: `${key.from}-${key.to}`,
                        label: getBudgetLabel(key, currency),
                        disabled,
                      };
                    })}
                    title="budget"
                  />) : null}

                <FilterStars
                  disabled={isSessionExpired || (!hotels?.length && !similarHotels?.length) || loadingFilter}
                  title="star.rating"
                  options={plainOptionsStar}
                  onChange={this.onStarsChange}
                  value={starRatings}
                />

                {isShowAmenities ? (
                  <>
                    <FilterBox
                      disabled={isSessionExpired || loadingFilter}
                      onChange={this.onAmenitiesChange}
                      values={amenities}
                      options={amenitiesToShow.map(({ count, key, disabled }) => {
                        const icon = TOP_AMENITIES_ICONS[key.toLowerCase()];
                        const amenityImage: any = getAmenityImageByName(key.toLowerCase());

                        return {
                          count,
                          value: key,
                          label: (
                            <div className="filter__icon-item">
                              {amenityImage?.image ? 
                                <img src={amenityImage.image} alt={key} width="20" /> : 
                                <span className="filter__icon-wrapper">{icon}</span>}
                              <span>
                                <Tooltip title={key}>{(key?.toString().length || 0) > 20 ? key?.toString().substring(0, 20) + '...' : key}</Tooltip>
                                {count > zero && (
                                  <span className="filter-box__option-count" style={{ marginLeft: '4px' }}>({count})</span>)}
                              </span>
                            </div>
                          ),
                          disabled,
                        };
                      })}
                      title="tab.amenities"
                      hideCount
                    />
                    {!isSessionExpired && sortedAmenities.length > maxAmenitiesCount && !loadingFilter && (
                      <div className="result-wrapper__show-link" onClick={this.toggleAmenities}>
                        {isFullAmenities ? (
                          <FormattedMessage id="show.less" />
                        ) : (
                          <FormattedMessage id="show.more" />
                        )}
                      </div>
                    )}
                  </>
                ) : null}

                {isShowAccommodationTypes ? (
                  <>
                    <FilterCheckbox
                      disabled={isSessionExpired || loadingFilter}
                      onChange={this.onAccommodationTypeChange}
                      values={accommodationType}
                      options={accommodationTypesToShow.map(({ count, key, disabled }) => {
                        return {
                          count,
                          value: key,
                          label: <span>{key}</span>,
                          disabled,
                        };
                      })}
                      title="accommodation.type"
                    />

                    {!isSessionExpired && resultCounters.propertyTypes?.length > maxAmenitiesCount && !loadingFilter && (
                      <div className="result-wrapper__show-link" onClick={() => this.setState({ isFullAccommodationTypes: !isFullAccommodationTypes })}>
                        {isFullAccommodationTypes ? (
                          <FormattedMessage id="show.less" />
                        ) : (
                          <FormattedMessage id="show.more" />
                        )}
                      </div>)}
                  </>) : null}

                {isShowAccessibility ? (
                  <>
                    <FilterCheckbox
                      disabled={isSessionExpired || loadingFilter}
                      onChange={this.onAccessibilityChange}
                      values={accessibility}
                      options={accessibilitiesToShow.map(({ count, key, disabled }) => {
                        return {
                          count,
                          value: key,
                          label: <span>{key}</span>,
                          disabled,
                        };
                      })}
                      title="accessibility"
                    />
                    {!isSessionExpired && resultCounters.accessibilities?.length > maxAmenitiesCount && !loadingFilter && (
                      <div className="result-wrapper__show-link" onClick={() => this.setState({ isFullAccessibilities: !isFullAccessibilities })}>
                        {isFullAccessibilities ? (
                          <FormattedMessage id="show.less" />
                        ) : (
                          <FormattedMessage id="show.more" />
                        )}
                      </div>)}
                  </>) : null}

                  {isShowPopularLocations ? (
                    <>
                      <FilterCheckbox
                        disabled={isSessionExpired || loadingFilter}
                        onChange={this.onPopularLocationChange}
                        values={popularLocations}
                        options={popularLocationsToShow.map(({ count, key, disabled }) => {
                          return {
                            count,
                            value: key,
                            label: <span>{key}</span>,
                            disabled,
                          };
                        })}
                        title="popular.locations"
                      />
                      {!isSessionExpired && resultCounters.popularLocations?.length > maxAmenitiesCount && !loadingFilter && (
                        <div className="result-wrapper__show-link" onClick={() => this.setState({ isFullPopularLocations: !isFullPopularLocations })}>
                          {isFullPopularLocations ? (
                            <FormattedMessage id="show.less" />
                          ) : (
                            <FormattedMessage id="show.more" />
                          )}
                        </div>)}
                    </>) : null}

                {isShowMealPlans ? (
                  <>
                    <FilterCheckbox
                      disabled={isSessionExpired || loadingFilter || loadingFilter}
                      onChange={this.onBoardNameChange}
                      values={boardNames}
                      options={boardNamesToShow.map(({ count, key, disabled }) => {
                        return {
                          count,
                          value: key,
                          label: <span>{key}</span>,
                          disabled,
                        };
                      })}
                      title="meal.plan"
                    />
                    {!isSessionExpired && resultCounters.boardNames?.length > maxAmenitiesCount && !loadingFilter && (
                      <div className="result-wrapper__show-link" onClick={() => this.setState({ isFullMealPlans: !isFullMealPlans })}>
                        {isFullMealPlans ? (
                          <FormattedMessage id="show.less" />
                        ) : (
                          <FormattedMessage id="show.more" />
                        )}
                      </div>)}
                  </>) : null}

                {isFiltersApplied && !isSessionExpired && !loadingFilter && (
                  <div className="result-wrapper__reset-filters-wrapper">
                    <span
                      className="result-wrapper__reset-filters-link"
                      onClick={() => this.onResetFilters()}
                    >
                      <FormattedMessage id="reset.all" />
                    </span>
                  </div>
                )}

                {!isSessionExpired && applyFilters?.length > 0 && (
                  <div className="result-wrapper__filters-apply">
                    <BlueButton onClick={this.onApply} disabled={isSessionExpired || loadingFilter}>
                      <FormattedMessage id="apply" />
                      <span className="result-wrapper__filters-apply-counts">
                        {applyFilters.length}
                      </span>
                      <FormattedMessage id="filters" />
                    </BlueButton>
                  </div>)}
              </div>
            </div>}

          {((loadingQuick && !loadingMore) || ((loadingSimilar || loadingMore) && !resultCounters)) && 
            <div
              className={`result-wrapper__filters-wrapper ${isMobileFilter ? 'is-mobile' : ''} ${
                isSessionExpired ? 'disabled' : ''} ${!showFilters ? 'hite-filters' : ''}`}
              ref={this.wrapperRef}
              style={{ minWidth: '270px' }}
            >
              <SkeletonFilters />
            </div>}

          <div className={`result-wrapper__btn-view-wrapper ${isSessionExpired ? 'disabled' : ''}`}>
            <WhiteButton onClick={this.onMobileFilter} disabled={isSessionExpired || loadingFilter}>
              <FilterSvg />
              <FormattedMessage id="sort.filter" />
            </WhiteButton>
            <WhiteButton
              disabled={isSessionExpired || loadingFilter}
              onClick={() => this.showMap(Map.getGoogleLocation(location?.geoLocation || { latitude: 0, longitude: 0 }))}
            >
              <MapSvg />
              <FormattedMessage id="view.map" />
            </WhiteButton>
          </div>

          {isMapView ? (
            <div className="result-wrapper__map-wrapper">
              <div className="result-wrapper__map-top">
                <div className="result-wrapper__map-close" onClick={this.showListView}>
                  <CloseSvg />
                </div>
                <div className="result-wrapper__map-location">{hotelsStore.searchedLocation}</div>
                <div
                  className={`result-wrapper__map-filters ${isSessionExpired || loadingFilter ? 'disabled' : ''}`}
                  onClick={this.onMobileFilter}
                >
                  <FilterSvg />
                </div>
              </div>


              {matches && (
                <SearchPropertyName
                  disabled={isSessionExpired || loadingFilter}
                  onSaveValue={this.onSearchSave}
                  title="search.property.name"
                  isMapView={isMapView}
                />
              )}

              {mapHotelsList ? (
                <MapWrapper
                  bounds={!!hotels?.length ? bounds : boundsSimilar}
                  disabled={isSessionExpired}
                  hotels={mapHotelsList}
                  locations={mapHotelsList.map(({ location, hotelId, pricePerNight, availability }) => ({
                    location,
                    id: hotelId,
                    pricePerNight,
                    availability
                  }))}
                  nights={resultCounters?.totalNights}
                  mapOptions={{ disableDefaultUI: true, zoomControl: true }}
                  withEvents={true}
                  selectedHotel={selectedHotel}
                  onSearchUpdate={this.onMapSearchUpdate}
                  setBounds={setBounds}
                  isVacationRentals={isVacationRentals}
                />
              ) : null}
            </div>
          ) : (
            <div
              className={`result-wrapper__content-wrapper ${isMobileFilter ? 'is-mobile' : ''} ${isEmptySearch ? 'is-empty-search' : ''}`}
              style={{ paddingBottom: loadingMore ? '0px' : isEmptySearch ? '100px' : '250px' }}
            >
              {hotelcompare?.length ? (
                <>
                  <div className="result-wrapper__compare-message">
                    {hotelcompare.length > 1 ? (<FormattedMessage id="results.hotel.card.compare.message" values={{ selected: hotelcompare.length, total: maxCompareHotels }} />) : null}
                    {hotelcompare.length === 1 ? (<FormattedMessage id="results.hotel.card.compare.message.select_more" />) : null}
                    <div className="compare-buttons">
                      {hotelcompare.length ? (
                        <WhiteButton className="compare-clear-button" onClick={() => this.props.setHotelToCompare([])}>
                          <FormattedMessage id="results.hotel.card.compare.clear_selection" />
                        </WhiteButton>) : null}

                      <BlueButton className="compare-button" disabled={hotelcompare.length <= displayCompareLength} onClick={() => this.setState({ showCompareModal: true })}>
                        {HasViewQuotesSharePermission ? <FormattedMessage id="results.hotel.card.compare.share" /> : <FormattedMessage id="results.hotel.card.compare" />}
                      </BlueButton>
                    </div>
                  </div>

                  <ModalCompare
                    visible={showCompareModal}
                    hotels={hotelcompare}
                    rooms={[...rooms]}
                    checkIn={startDate}
                    checkOut={endDate}
                    isVacationRentals={isVacationRentals}
                    locationCode={location?.code?.toString() || ''}
                    sessionKey={sessionKey as ISessionKey}
                    onCancel={() => this.setState({ showCompareModal: false })}
                    onRemove={this.handleCompare}
                  />
                </>
              ) : null}

              {!isNewTemplate && displaySelectedFiltersHeader && (
                <SelectedFiltersHeader isVacationRentals={isVacationRentals} onFiltersOrSortChange={this.onFiltersOrSortChange} />)}

              {isSessionExpired && (
                <div className="result-wrapper__expired-message">
                  <ExpiredSessionModal visible={isSessionExpired} />
                </div>
              )}

              {(isEmptySearch && !loadingSimilar && !similarHotels?.length && !loadingMore && !loadingFilter && !loading)? (
                isFiltersApplied ? (
                  <>
                    {location?.type !== 'Hotel' && this.homesFilterComponent()}

                    <EmptyFilterMessage />
                  </>
                ) : (
                  <EmptySearchMessage
                    label={
                      lastSearchedLocation && lastSearchedLocation.type === LocationsTypes.Hotel
                        ? "sorry.could.not.find.the.specified.hotel"
                        : NULL_VALUE
                    }
                    isVacationRentals={isVacationRentals}
                    filterHomes={this.props.filtersStore.searchHomes}
                    location={searchedLocation}
                    account={account as IAccount}
                  />
                )
              ) : (
                <>
                  {(!loadingFilter && !isEmptySearch) && (
                    <div className="result-wrapper__top-section">
                      <div className="col-12">
                        <div className="row">
                          {(location?.type !== 'Hotel' && !isVacationRentals && !account?.forceDisableVacationRentals && !isAllInclusive && !account?.isSundance) && 
                            <div className={account?.isNewTemplate ? 'col-md-12 col-sm-8' : 'col-md-5 col-sm-8'}>
                              {this.homesFilterComponent()}
                            </div>}

                          {isNewTemplate && displaySelectedFiltersHeader && (
                            <div className="col-md-12 col-sm-8">
                              <SelectedFiltersHeader isVacationRentals={isVacationRentals} onFiltersOrSortChange={this.onFiltersOrSortChange} />
                            </div>)}

                          <div className={account?.isNewTemplate
                            ? ((isCapital && !isCapitalAgent) ? 'col-md-6' : 'col-md-9')
                            : ((location?.type !== 'Hotel' && !isVacationRentals && !account?.forceDisableVacationRentals && !isAllInclusive && !isCapital && !account?.isSundance) ? "text-center col-md-3" : (isCapital && !isCapitalAgent && !isMobile) ? "col-md-5" : "col-md-9")
                          }>
                            {!loadingQuick ? (
                              <p className="result-wrapper__top-header">
                                {((location?.type === 'Hotel' && totalFilteredHotelsTotal) || location?.type !== 'Hotel') && (
                                  <FormattedMessage
                                    id="properties.found"
                                    values={{ count: totalFilteredHotelsTotal }}
                                  />)}

                                {location?.type === 'Hotel' && !totalFilteredHotelsTotal && (
                                  <FormattedMessage
                                    id="properties.found"
                                    values={{ count: totalFilteredHotelsTotal }}
                                  />)}
                              </p>) : (
                              <Skeleton active title paragraph={false} style={{ marginTop: '15px', width: '90%' }} />)}
                          </div>

                          {(isCapital && !isCapitalAgent) ? (
                            <div className={isMobile ? 'col-md-4 col-sm-4' : 'col-md-3 col-sm-3'}>
                              <div className="result-wrapper__sort-select capital-vacations">
                                {!isNewTemplate && (
                                  <span className="result-wrapper__sort-label">
                                    <FormattedMessage id="lifestyle.change" />{' '}
                                  </span>)}
                                <CustomSelect
                                  disabled={isSessionExpired || loadingFilter || loadingQuick}
                                  value={lifeStyle as string}
                                  onChange={this.onLifeStyleChange}
                                  options={GetLifeStyleStores()}
                                />
                              </div>
                            </div>) : null}

                          {!isMobile ? (
                            <div className={(isCapital && !isNewTemplate) ? 'col-md-4 col-sm-4' :  !isNewTemplate && !isVacationRentals ? 'col-md-4 col-sm-4' : 'col-md-3 col-sm-3'}>
                              <div className="result-wrapper__sort-select">
                                {!isNewTemplate && (
                                  <span className="result-wrapper__sort-label">
                                    <FormattedMessage id="sort.by" />{' '}
                                  </span>)}
                                <CustomSelect
                                  disabled={isSessionExpired || loadingFilter || loadingQuick}
                                  value={sortBy}
                                  onChange={this.onSortChange}
                                  options={this.getSortOptions()}
                                />
                              </div>
                            </div>) : null}
                        </div>
                      </div>
                    </div>)}

                  {hasClientCash && walletHasSliderOnSearch ? (
                    <div 
                      className="result-wrapper__top-section"
                      style={{
                        backgroundColor: '#FFFFFF',
                        marginBottom: '20px',
                        borderRadius: (isCapital ? '0px' : '5px'),
                        marginTop: (isCapital ? '8px' : '0px'),
                        minHeight: 'unset',
                        border: (isCapital ? '3px solid #006098' : '1px solid #D2D2D2') }}
                    >
                      <WalletSearchSlider
                        display={true}
                        selectedClientCash={selectedHotelSearchClientCash?.selectedSearchClientCash as number}
                        onSelectClientCash={this.handleOnSelectClientCash}
                      />
                    </div>) : null}

                  {(!loadingFilter && !isEmptySearch) ? (
                    <div className="result-wrapper__next-reward">
                      <WalletNextRewardCard />
                    </div>
                  ) : null}

                  {!loadingFilter ? (
                    hotels.map((hotel: IHotel, index: number) => {
                      const isInCompareList = hotelcompare?.map(h => h.hotelId).includes(hotel.hotelId);
                      return (
                        <div key={hotel.hotelId}>
                          <Responsive>
                            <HotelCardComponent
                              disabled={isSessionExpired || loadingFilter}
                              hotel={hotel}
                              nights={!hotel?.possibleStays?.length ? (resultCounters?.totalNights || 0) : get(hotel, 'possibleStays[0].days', 0)}
                              showOnMap={() =>
                                this.showMap(Map.getGoogleLocation(hotel.location), hotel)
                              }
                              compared={isInCompareList}
                              displayCompare={true}
                              disableCompare={!(hotels?.length > displayCompareLength && (isInCompareList || hotelcompare?.length < maxCompareHotels))}
                              onCompareSelect={this.handleCompare}
                              isVacationRentals={isVacationRentals}
                            />
                          </Responsive>
                          {(index === 2 || location?.type === 'Hotel') && (<Banner type={SEARCH_BANNER_TYPE}></Banner>)}
                        </div>
                      );
                    })
                  ) : (
                    <SkeletonContent label={''} isTitle={false} />
                  )}

                  {loadingMore && !loadingFilter && 
                    <SkeletonContent label={''} isTitle={false} />}
                </>
              )}

              {!loadingFilter && (
                <>
                  {(location?.type === 'Hotel' && !hotels.length && !isFiltersApplied && !loadingMore && (!isMinProfit || !loadingSimilar)) && (
                    <p className="no-result-msg__title" style={{ marginBottom: '20px' }}>
                      <FormattedMessage id="property.soldout" />
                    </p>)}

                  {(loadingSimilar || (loadingMore && !!similarHotels?.length)) && (
                    <div className="result-wrapper__similar-hotels-container">
                      <SkeletonContent label={''} isTitle={false} />
                    </div>)}

                  {!!similarHotels?.length && (
                    <div className="result-wrapper__similar-hotels-container">
                      {(!loadingSimilar && !!similarHotels?.length) && (
                        <div className="similar-hotels-title">
                          {hotels?.length ? 
                              location?.type !== 'Hotel' ? 
                                  'Your destination has limited availability, so we’ve included nearby hotels to expand your choices' : 
                                  'Other hotels in the same destination' : 
                              <FormattedMessage id="no.properties.similar" />}
                        </div>)}

                      {!loadingSimilar && (
                        <>
                          {similarHotels?.map((hotel: IHotel) => {
                             const isInCompareList = hotelcompare?.map((h) => h.hotelId).includes(hotel.hotelId);
                            return (
                              <div key={hotel.hotelId}>
                              <Responsive key={hotel.hotelId}>
                                <HotelCardComponent
                                  disabled={isSessionExpired}
                                  hotel={hotel}
                                  nights={!hotel?.possibleStays?.length ? (resultCounters?.totalNights || 0) : get(hotel, 'possibleStays[0].days', 0)}
                                  isSimilar={true}
                                  displayCompare={true}
                                  showOnMap={() => this.showMap(Map.getGoogleLocation(hotel.location), hotel)}
                                  isVacationRentals={isVacationRentals}
                                  compared={isInCompareList}
                                  disableCompare={!(similarHotels?.length > displayCompareLength &&(isInCompareList ||hotelcompare?.length < maxCompareHotels))}
                                  onCompareSelect={this.handleCompare}
                                />
                              </Responsive>
                              </div>
                            );
                          })}
                        </>
                      )}
                    </div>
                  )}
                </>
              )}

              {(!loadingFilter && !loadingMore && !loadingSimilar && !loading) && (
                <SelectedFiltersFooter isVacationRentals={isVacationRentals} onFiltersOrSortChange={this.onFiltersOrSortChange} />)}

            </div>
          )}
        </div>

        {mapLoading && isMapView && <SkeletonMap />}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    hotelsStore: state.hotelsStore,
    datesStore: state.datesStore,
    locationsStore: state.locationsStore,
    roomsStore: state.roomsStore,
    filtersStore: state.filtersStore,
    loginStore: state.loginStore,
    savedPropertiesStore: state.savedPropertiesStore,
    sharecompareStore: state.compareStore,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<RootState, undefined, Action>,
): IMapDispatchToProps => ({
  setPageNumber: () => {
    dispatch(hotelsActions.setPageNumber());
  },
  resetHotels: () => {
    dispatch(resetHotels());
  },
  resetHotelsFull: () => {
    dispatch(resetHotelsFull());
  },
  getHotels: (
    location: ILocation,
    isLoadMore: boolean,
    isFiltersChange: boolean,
  ) => {
    dispatch(getHotels(location, isLoadMore, isFiltersChange));
  },
  getMapHotels: (
    location: ILocation,
    startDate: string | null | undefined,
    endDate: string | null | undefined,
    rooms: IRoom[],
    hotelId: number = NULL_VALUE,
  ) => {
    dispatch(getMapHotels(location, startDate, endDate, rooms, hotelId));
  },
  getSimilarHotels: (isFiltersChange: boolean, isLoadMore: boolean) => {
    dispatch(getSimilarHotels(isFiltersChange, isLoadMore));
  },
  setLoadingFilter: (loadingFilter: boolean) => {
    dispatch(hotelsActions.setLoadingFilter(loadingFilter));
  },
  getSimilarHotelsNearBy: (isFiltersChange: boolean, isLoadMore: boolean) => {
    dispatch(getSimilarHotelsNearBy(isFiltersChange, isLoadMore));
  },
  setBudget: (value: string[]) => {
    dispatch(filtersActions.setBudget(value));
  },
  setAmenities: (value: string[]) => {
    dispatch(filtersActions.setAmenities(value));
  },
  setAccommodationType: (value: string[]) => {
    dispatch(filtersActions.setAccommodationType(value));
  },
  setAccessibility: (value: string[]) => {
    dispatch(filtersActions.setAccessibility(value));
  },
  setPopularLocations: (value: string[]) => {
    dispatch(filtersActions.setPopularLocations(value));
  },
  setBoardName: (value: string[]) => {
    dispatch(filtersActions.setBoardName(value));
  },
  setRefundable: (value: string[]) => {
    dispatch(filtersActions.setRefundable(value));
  },
  setFlexibleDate: (value: string[]) => {
    dispatch(filtersActions.setFlexibleDate(value));
  },
  setNeighbourhoods: (value: string[]) => {
    dispatch(filtersActions.setNeighbourhoods(value));
  },
  setPlaces: (value: string[]) => {
    dispatch(filtersActions.setPlaces(value));
  },
  setStarRating: (value: number[]) => {
    dispatch(filtersActions.setStarRating(value));
  },
  setSortBy: (value: string) => {
    dispatch(filtersActions.setSortBy(value as SortTypes));
  },
  resetFiltersByType: (filterType: IFilterType, isQuickEnabled: boolean) => {
    dispatch(filtersActions.resetFiltersByType({ filterType, isQuickEnabled }));
  },
  validateLocation: (error: string) => {
    dispatch(locationActions.setError(error));
  },
  setSelectedCompareHotels: (selectedCompareHotels: IHotel[]) => {
    dispatch(hotelsActions.setSelectedCompareHotels(selectedCompareHotels));
  },
  setBounds: (bounds: IBounds) => {
    dispatch(hotelsActions.setBounds(bounds));
  },
  setMapLoading: (isMapLoading: boolean) => {
    dispatch(hotelsActions.setMapLoading(isMapLoading));
  },
  setIsMapView: (isMapView: boolean) => {
    dispatch(hotelsActions.setIsMapView(isMapView));
  },
  setSearchHomes: (value: string) => {
    dispatch(filtersActions.setSearchHomes(value as HomesTypes));
  },
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => {
    dispatch(hotelsActions.setSelectedHotelSearchClientCash(selectedClientCash));
  },
  getUserWallet: (user: IUser) => {
    dispatch(getUserWallet(user));
  },
  setLifeStyle: (value: string) => {
    dispatch(loginActions.setLifeStyle(value));
  },
  setHotelToCompare: (hotelcompare: IHotel[]) => {
    dispatch(compareActions.setHotelToCompare(hotelcompare));
  },
  setHotelCompareStartDate: (value: string) => {
    dispatch(compareActions.setHotelCompareStartDate(value as string));
  },
  setHotelCompareEndDate: (value: string) => {
    dispatch(compareActions.setHotelCompareEndDate(value as string));
  },
  setclearHotelsCompare: () => {
    dispatch(compareActions.setclearHotelsCompare());
  },
  setFilters: (filters: IFiltersState) => {
    dispatch(filtersActions.setFilters(filters));
  },
  
});

export const ResultWrapper = connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(withRouter(ResultWrapperComponent)));
